module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    staticClass: "gTopMg",
    attrs: {
      "label-position": "right",
      "label-width": "14.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_hbsp') + '(' + (_vm.$t('app_minute')) + ')',
      "prop": "name"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 1,
      "max": 20
    },
    model: {
      value: (_vm.terminalConfigForm.data.set.hb),
      callback: function($$v) {
        _vm.$set(_vm.terminalConfigForm.data.set, "hb", $$v)
      },
      expression: "terminalConfigForm.data.set.hb"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_checkupsp') + '(' + _vm.$t('app_minute') + ')',
      "prop": "name"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": _vm.terminalConfigForm.data.set.hb + 5,
      "max": 120
    },
    model: {
      value: (_vm.terminalConfigForm.checkUpdateTime),
      callback: function($$v) {
        _vm.$set(_vm.terminalConfigForm, "checkUpdateTime", $$v)
      },
      expression: "terminalConfigForm.checkUpdateTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_rcmsg')
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.terminalConfigForm.data.get),
      callback: function($$v) {
        _vm.$set(_vm.terminalConfigForm.data, "get", $$v)
      },
      expression: "terminalConfigForm.data.get"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "l"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_geo')))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "si"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sysinfo')))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "ts"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_terstatus')))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "fi"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fminfo')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveTerminalConfig()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a243444"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/param/sysSetting.vue
// module id = 962
// module chunks = 0